export default __webpack_public_path__ + "a1e0408c8d9ac6372fcdc563189641af.gif";